<img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logo">
<a href="#" (click)="exploreClick()">
  <img src="../../assets/planetzoomedout.svg" alt="planet" class="planet" [ngClass]=exploreClass>
  <img src="../../assets/arrow.svg" alt="arrow" id="arrow">
  <p id="explore">Let's explore!</p>
</a>
<a appTicketRocket>
  <img src="../../assets/rockettickets.png" alt="buy tickets" class="tickets">
</a>
<div id="social">
  <a href="#">
    <i class="fab fa-facebook-square icon"></i>
  </a>
  <a href="#">
    <i class="fab fa-instagram-square icon"></i>
  </a>
  <p id="date">2 oktober 2020</p>
</div>
<a href="#sponsors" id="seeSponsors">Sponsors v</a>
<div class="footer" id="sponsors">
    <img src="../../assets/sponsors/bxl.png" alt="">
    <img src="../../assets/sponsors/cegeka.png" alt="">
    <img src="../../assets/sponsors/cronos.png" alt="">
    <img src="../../assets/sponsors/ehb.png" alt="">
    <img src="../../assets/sponsors/flanders.png" alt="">
    <img src="../../assets/sponsors/imec.png" alt="">
    <img src="../../assets/sponsors/meetdistrict.png" alt="">
    <img src="../../assets/sponsors/overheid.png" alt="">
    <img src="../../assets/sponsors/showpad.png" alt="">
    <img src="../../assets/sponsors/voka.png" alt="">
</div>
